const price_guide = {
  headline: 'Plumbing Price Guide',
  content:
    "When it comes to hiring a plumber, understanding pricing for common services essential. Whether you're dealing with a leaky faucet, a clogged drain, or a full- scale plumbing project, knowing what things cost ahead of time is invaluable.Below we’ll break down what you can expect to pay for some of the more common plumbing services.These are just ranges as there are many factors involved with getting an exact price, geographic area being one of the main ones.Hopefully this guide will help you make a more informed decision the next time you need to hire a plumber.",
  data: [
    {
      label: 'Clearing a clogged drain',
      cost: '$100 to $300'
    },
    {
      label: 'Fixing a leaky faucet',
      cost: '$75 to $200'
    },
    {
      label: 'Repairing a burst pipe',
      cost: '$200 to $600'
    },
    {
      label: 'Installing a new toilet',
      cost: '$200 to $500'
    },
    {
      label: 'Replacing a garbage disposal',
      cost: '$150 to $450'
    },
    {
      label: 'Fixing a running toilet',
      cost: '$100 to $250'
    },
    {
      label: 'Installing a new showerhead',
      cost: '$50 to $150'
    },
    {
      label: 'Repairing a water heater',
      cost: '$150 to $500'
    },
    {
      label: 'Installing a new water heater',
      cost: '$800 to $1,500'
    },
    {
      label: "Fixing a toilet that won't flush",
      cost: '$100 to $300'
    },
    {
      label: 'Repairing a leaky pipe',
      cost: '$150 to $350'
    },
    {
      label: 'Installing a new sink',
      cost: '$200 to $500'
    },
    {
      label: 'Fixing low water pressure',
      cost: '$100 to $250'
    },
    {
      label: 'Repairing a sump pump',
      cost: '$200 to $500'
    },
    {
      label: 'Installing a new sump pump',
      cost: '$500 to $1,000'
    }
  ]
};

export default price_guide;
